import axiosInstance from "../../api/axios";

// Contact List
export const getContacts = async () => {
  try {
    const response = await axiosInstance.get(`/contact/list/`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Contact Delete
export const deleteContact = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/contact/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};